export const DEFAULT_GOOGLE_MAPS_API_KEY = 'AIzaSyBUpVclOi0qnvcIqhnl6u5PEw73jCrdVyY';
